'use strict';

import dwUtils from '../util';
import * as Utils from '../helpers/born.utils';
import {breakpoints, toggleOverlay, isMobile} from '../helpers/born.utils';
import TrackingLayer from '../modules/module.tracking-layer';
import dwValidator from '../validator';

var progress = require('../progress'),
    page = require('../page'),
    util = require('../util');

var SIGNUP_DETAILS = '.js-subscribersignup__details';

function addSignupHandler() {
    let form = $('.js-subscribersignup'),
        subFormSettings = $.extend(true, {submitHandler: sendSignupRequest}, dwValidator.settings),
        ref = $(form).find('[name$=ref]').val();

    dwValidator.initForm(form, subFormSettings);
 
    let page = {
        type:"Newsletter", 
        breadcrumb: ["Home", "Newsletter", "Subscribe"]
    };

    if(ref && ref != 'stringEmpty') { 
        page.page_ref = ref; 
    }

    TrackingLayer.pushData(page, 'page');
}

function sendSignupRequest(form) {
    progress.show($(SIGNUP_DETAILS));
    TrackingLayer.pushData('mail_signup: ' + window.Resources['SUBSCRIBE_SIGNUP']);

    return true;
}

function initEventHandlers() {
	addSignupHandler();
};

function genderSelectionCheckmarkToggle() {
    $('.form-gender-radio').each(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('selected');
        }
    });
    $('.form-gender-radio').on('change', function () {
        $('.form-gender-selection-radio').removeClass('selected');
        $(this).parent().addClass('selected');
    });
}

exports.init = function () {
    initEventHandlers();
    genderSelectionCheckmarkToggle();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/subscribersignuppage.js